import type { HigherPeriod, Period } from '@/entities/types';
import { planCreateSchema } from './schema';
import type { PlanCreate } from './types';

export interface PlanCreateInput {
  period: Period;
  startAt: Date;
  startAtLocal: string;
}

export function preparePlanCreate(data: PlanCreateInput): PlanCreate {
  return planCreateSchema.parse({
    ...data,
    id: crypto.randomUUID(),
  });
}

export function buildPlanningStatuses(
  plannedPeriods: HigherPeriod[],
  checks: Array<{ period: HigherPeriod; startAtLocal: string }>,
): Record<HigherPeriod, boolean> {
  const plannedSet = new Set(plannedPeriods);
  return Object.fromEntries(
    checks.map(({ period }) => [period, plannedSet.has(period)]),
  ) as Record<HigherPeriod, boolean>;
}
